<template>
    <div v-if="children.length" class="secondary-menu">
        <div class="tab-container">
            <div
                v-for="(child, index) in children"
                :key="child.name"
                :class="['tab-item', {
                    active: child.name === activeChild,
                    disabled: child.disabled
                }]"
                @click="!child.disabled && handleTabClick(child.name)"
            >
                <span class="tab-label">{{ child.title }}</span>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: 'SecondaryMenu',
    props: {
        children: {
            type: Array,
            default: () => []
        },
        activeChild: {
            type: String,
            default: ''
        }
    },
    methods: {
        handleTabClick(name) {
            this.$emit('child-change', name)
        }
    }
}
</script>

<style scoped>
.tab-item.disabled {
    cursor: not-allowed;
    color: #cccccc;
}
.tab-item.disabled:hover {
    background: #f5f5f5;
    color: #cccccc;
    box-shadow: none;
}
.secondary-menu {
    background: transparent;
    width: 100%;
    padding: 12px 20px 8px;
    border-bottom: 1px solid #e5e5e5;
}

.tab-container {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #fff;
    padding: 14px;
    border-radius: 35px;

}

.tab-item {
    position: relative;
    padding: 8px 16px;
    border-radius: 20px;
    color: #666666;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    user-select: none;
    display: flex;
    align-items: center;
    min-height: 32px;
    border: 1px solid transparent;

    &:hover,
    &:focus {

    }
}

.tab-item:hover:not(.active) {
    background: rgba(64, 158, 255, 0.08);
    color: #409eff;
}

.tab-item.active {
    color: #ffffff;
    font-weight: 500;
    box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
    background-image: linear-gradient(117deg, #1280ff 0%, #a32cdf 100%);
    filter: brightness(1.05); /* ����ʱ���� */
}

.tab-label {
    display: inline-block;
}

.tab-badge {
    position: absolute;
    top: -6px;
    right: -6px;
    font-size: 10px;
    font-weight: 400;
    line-height: 1;
    padding: 2px 4px;
    border-radius: 8px;
    color: #ffffff;
    transform: scale(0.9);
    z-index: 1;
}


.tab-badge.orange {
    background: #ff8c00;
}

/* ��Ӧʽ���� */
@media (max-width: 768px) {
    .secondary-menu {
        padding: 8px 12px 4px;
    }

    .tab-container {
        gap: 4px;
    }

    .tab-item {
        padding: 6px 12px;
        font-size: 13px;
        min-height: 28px;
    }

    .tab-badge {
        font-size: 9px;
        padding: 1px 3px;
    }
}</style>
